import Component from '../core/Component'
import debounce from 'lodash/debounce'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export default class BackgroundNumber extends Component {
    constructor(element) {
        super(element)

        this.handleResize = debounce(::this.handleResize, 100)
        this.resize()
        this.shadow = {
            x: 0,
            y: 40
        }

        this.enquireHandler = {
            match: ::this.attach,
            unmatch: ::this.detach
        }
    }

    prepare() {
        enquire.register(queries.mediumUp, this.enquireHandler)
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('mousemove', this.handleMouseMove)
        enquire.unregister(queries.mediumUp, this.enquireHandler)
    }

    attach() {
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('mousemove', this.handleMouseMove)
        this.render()
    }

    detach() {
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('mousemove', this.handleMouseMove)
    }

    handleResize() {
        this.resize()
    }

    handleMouseMove = event => {
        const { clientX, clientY } = event

        const vectorX = clientX - this.box.centerX
        const vectorY = clientY - this.box.centerY

        const length = Math.hypot(vectorX, vectorY)

        const unitVector = {
            x: vectorX/length,
            y: vectorY/length
        }

        const coef = Math.min(1, length/400)

        this.shadow = {
            x: -unitVector.x * 40 * coef,
            y: -unitVector.y * 40 * coef
        }

        this.render()

    }

    resize() {
        const box = this.element.getBoundingClientRect()

        this.box = {
            x: box.left,
            y: box.top,
            width: box.width,
            height: box.height,
            centerX: box.left + box.width / 2,
            centerY: box.top + box.height / 2
        }
    }

    render() {
        this.element.style.textShadow = `${this.shadow.x}px ${this.shadow.y}px 50px rgba(12, 39, 53, 0.1)`
    }

}


// WEBPACK FOOTER //
// ./components/BackgroundNumber.js